/**
 * Canonical coordinate normaliser.
 *
 * Used before both the map and the list receive a station, so the
 * two are guaranteed to see the same shape (real, in-range numbers
 * or null). Historically the map and the list used different
 * heuristics — the map accepted string-coerced numeric via
 * `Number(v)` (works, since PostgreSQL NUMERIC columns come back
 * from node-postgres as strings) while `normaliseStation` did
 * `typeof v === 'number'`, which silently rejected the same
 * strings. That divergence caused the "map has pins but list has
 * no Get-directions button" bug.
 *
 * Accepts strings or numbers; rejects NaN, Infinity, and values
 * outside the caller-specified WGS84 range. Returns a plain
 * number or null — never `undefined`.
 */
export function normaliseCoordinate(value, min, max) {
  const parsed = typeof value === 'string' ? Number.parseFloat(value) : value;
  return Number.isFinite(parsed) && parsed >= min && parsed <= max
    ? parsed
    : null;
}

// Convenience wrappers so callers don't have to remember the WGS84
// ranges every time.
export function normaliseLat(value) {
  return normaliseCoordinate(value, -90, 90);
}

export function normaliseLng(value) {
  return normaliseCoordinate(value, -180, 180);
}
